import ContentArea from '@episerver/spa-core/Components/ContentArea';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import BlockWrapper from 'app/Components/Shared/BlockWrapper';
import PackagesItemsBlockData from 'Models/Content/PackagesItemsBlockData';
import React from 'react';
import {Container} from 'reactstrap';

const PackagesItemsBlock = (props: ComponentProps<PackagesItemsBlockData>) => {
  const {data, context} = props;

  return (
    <BlockWrapper props={props}>
      <div className='PackagesItemsBlock'>
        <div className='PackagesItemsBlock__container'>
          <Container className='PackagesItemsBlock__container__items'>
            <div className='PackagesItemsBlock__container__items__wraper'>
              <ContentArea noWrap data={data.cellularItems} context={context} />
            </div>
          </Container>
        </div>
      </div>
    </BlockWrapper>
  );
};

export default PackagesItemsBlock;
